const dynamicPackage = {
  detailedPlan: "Gedetailleerd plan", // translated
  minimum: "Minimum", // translated
  maximum: "Maximaal", // translated
};

export default dynamicPackage;
